import Flex from './layouts/Flex';
import AlertSvg from 'imagesUwKluis/svg/alertfill.svg';
import WarningSvg from 'imagesUwKluis/svg/info.svg';
import { WithIcon } from './layouts';
import theme from "../../theme";

type Props = {
  children: React.ReactNode;
  withIcon?: boolean;
  severity?: 'error' | 'warning';
}

const AlertMessageBanner = ({ children, withIcon = true, severity = 'error' }: Props) => {
  let alertIcon: JSX.Element;
  let backgroundColor: string;
  let colorName: keyof typeof theme.colors;

  switch (severity) {
    case 'warning':
      alertIcon = <WarningSvg width="16px" height="16px" fill={theme.colors.warningForeground} />;
      colorName = 'warningForeground';
      backgroundColor = theme.colors.warningBackground;
      break;
    case 'error':
    default:
      alertIcon = <AlertSvg width="20px" height="20px" />;
      colorName = 'alert';
      backgroundColor = `${theme.colors.alertHover}28`;
      break
  }

  return (
    <Flex
      width={'100%'}
      p="s"
      mt="s"
      backgroundColor={backgroundColor}
      fontWeight={{ mobile: 'bolder', desktop: 'bold' }}
      fontScale={'s'}
      borderRadius={'4px'}
      color={colorName}
    >
      <WithIcon color={colorName}>
        {withIcon && alertIcon}
        {children}
      </WithIcon>
    </Flex>
  );
};
export default AlertMessageBanner;
